export default {
    routerName: 'ユーザー編集',
    user: {
        icon: 'アイコン',
        deptName: '部門名',
        name: '氏名',
        loginName: 'アカウント',
        email: 'メール',
        password: 'パスワード',
        mobile: '電話番号',
        type: 'タイプ',
        systemUser: 'システムユーザー',
        normalUser: '普通ユーザー',
        members: '会員ユーザー',
        sex: '性别',
        status: '状態',
        remark: '備考',
        male: '男性',
        female: '女性',
        open: '有効',
        close: '無効',
        postName: '職位',
        roleName: 'ロール',
    },
    info: {
        accountNotChange: 'ユーザー登録後でアカウントが変更できません。',
    },
    role: {
        roleDistribute: '配分',
    },
};
